var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-app",
    [
      _c("div", { attrs: { id: "dpi-getter" } }),
      _vm.initingDossierData
        ? _c("app-init-dossier-progress", {
            attrs: { progress: _vm.initingDossierData.progress },
          })
        : _c("router-view"),
      _c("app-motd"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }